module.exports = __webpack_public_path__ + "img/heart-half.81c13e70.svg";